import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { ENUM_MODALS_VALUE, setModals } from "../../store/commonSlice";
import { setIsAnonymity } from "../../store/chatSlice";
import { useAppSelector } from "../../store/index.ts";
import ModalPrivate from "./ModalPrivate.jsx";
import { ENUM_CHAT_MODE } from "../common/enums.js";

export default function PrivatModalContainer() {
  const dispatch = useDispatch();
  const isPrivate = useAppSelector((state) => state.common.modals.private);
  const activeMode = useAppSelector((state) => state.chat.chatActiveMode);

  const isPrivateMode = useMemo(
    () => [ENUM_CHAT_MODE.exclusive, ENUM_CHAT_MODE.private].includes(activeMode),
    [activeMode]
  );

  const closePrivate = () => dispatch(setModals({ name: ENUM_MODALS_VALUE.private, value: false }));

  useEffect(() => {
    dispatch(setIsAnonymity(isPrivateMode));
  }, [isPrivateMode]);

  return <ModalPrivate isOpen={isPrivate} closeModal={closePrivate} />;
}
